import { filter, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { Router, UrlTree } from '@angular/router';
import { selectWorkspaceFromUrlStatus, WorkspaceFromUrlStatus } from '@mkp/auth/state';
import { concatLatestFrom } from '@ngrx/operators';
import { selectIsBoUser } from '@mkp/user/state-logged-in/selectors';
import { selectSelectedAccount } from '@mkp/account/state';
import { isNotNull } from '@mkp/shared/util-guards';
import { getLoadedResult } from './helpers';

export const hasSelectedWorkspaceFromUrlGuard: () => Observable<boolean | UrlTree> = () => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(selectWorkspaceFromUrlStatus).pipe(
    filter((state) => state === WorkspaceFromUrlStatus.COMPLETED),
    concatLatestFrom(() => [
      store.select(selectIsBoUser).pipe(filter(isNotNull)),
      store.select(selectSelectedAccount),
    ]),
    map(([, isBoUser, selectedAccount]) => getLoadedResult(router, !!selectedAccount, isBoUser))
  );
};
